import React, { useState } from "react";

export default function BookAppointment({
  item,
  isOpen,
  onClose,
  onConfirm,
}) {
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");

  const timeSlots = item?.timeSlots || [
    "09:30 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
  ];

  const today = new Date().toISOString().split("T")[0];

  const handleConfirm = () => {
    if (!selectedDate || !selectedTime) return;

    const appointment = {
      doctorId: item?.id,
      doctorName: item?.title,
      specialization: item?.specialization,
      date: selectedDate,
      time: selectedTime,
    };

    onConfirm?.(appointment);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-3xl rounded-xl bg-white p-6">
        {/* Header */}
        {/* Header */}
<div className="flex items-center justify-between rounded-lg bg-slate-50 p-4">
  <div className="flex items-center gap-4">
    <img
      src={item?.profilePicture || item?.image}
      alt={item?.title || item?.name || "Doctor"}
      className="h-20 w-20 rounded-full object-cover bg-gray-200"
    />

    <div>
      <h3 className="text-lg font-semibold text-gray-900">
        {item?.title || item?.name}
      </h3>

      <p className="text-sm text-gray-500">
        {item?.degree
          ? `${item.degree} | ${item.specialization}`
          : item?.specialty}
      </p>

      {item?.hospitalName && (
        <p className="text-sm font-medium text-gray-700">
          {item.hospitalName}
        </p>
      )}

      <p className="text-xs text-gray-500">
        {item?.pincode || item?.location}
      </p>
    </div>
  </div>

  <button className="rounded-md border border-blue-600 px-4 py-2 text-sm text-blue-600 hover:bg-blue-50">
    Add Note
  </button>
</div>


        {/* Date Picker */}
        <div className="mt-6">
          <h4 className="mb-2 text-lg font-medium text-gray-900">
            Select Appointment Day
          </h4>

          <input
            type="date"
            min={today}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="w-60 rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* Time Slots */}
        <div className="mt-6">
          <h4 className="mb-3 text-lg font-medium text-gray-900">
            Available Time Slot
          </h4>

          <div className="grid grid-cols-3 gap-3">
            {timeSlots.map((slot) => (
              <button
                key={slot}
                onClick={() => setSelectedTime(slot)}
                className={`rounded-md border px-4 py-2 text-sm font-medium transition
                  ${
                    selectedTime === slot
                      ? "primary-bg text-white border-blue-700"
                      : "border-slate-300 text-blue-700"
                  }
                `}
              >
                {slot}
              </button>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="rounded-md border px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            disabled={!selectedDate || !selectedTime}
            className="rounded-md primary-bg px-6 py-2 text-sm font-medium text-white disabled:opacity-50"
          >
            Confirm Appointment
          </button>
        </div>
      </div>
    </div>
  );
}
